<template>
  <v-textarea
    @input="handleMeetingObservations"
    :label="$t('appointment.formCreate.labels.observations')"
    rows="4"
    no-resize
    outlined
  />
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'MeetingObservations',

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleMeetingObservations(value) {
      this.setAppointmentFields({
        observations: value,
      })
    },
  },
}
</script>
